import Cookies from 'js-cookie';

import {
  ACCESS_TOKEN_COOKIE,
  FANATICS_TENANT_ID_COOKIE,
} from '../../Auth/constants';
import { ENonProdEnvs } from '../../NonProdBanner/types';
import { decodeJwt } from '../decodeJwt';

export const isTestEnv = ({ hostname } = window.location) => {
  const array = hostname.split('.');
  return (
    array.slice(-1)[0] === 'localhost' ||
    (Object.values(ENonProdEnvs) as string[]).includes(
      array.slice(0, -2).slice(-1)[0]
    )
  );
};

export const getTenantId = () => {
  try {
    const tenantId = Cookies.get(FANATICS_TENANT_ID_COOKIE);

    if (tenantId) {
      return tenantId;
    }

    const pwccAccessToken = Cookies.get(ACCESS_TOKEN_COOKIE);

    if (pwccAccessToken) {
      return decodeJwt<{ tenant_id: string }>(pwccAccessToken).tenant_id;
    }
  } catch {
    return undefined;
  }
};
